import { render } from "./Español.vue?vue&type=template&id=1e453676"
import script from "./Español.vue?vue&type=script&lang=js"
export * from "./Español.vue?vue&type=script&lang=js"

import "./Español.vue?vue&type=style&index=0&id=1e453676&lang=css"

import exportComponent from "D:\\rober\\RobertVS\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__